// @flow
export const confirm = (question: string): Promise<*> =>
  new Promise((resolve, reject) => (global.confirm(question) ? resolve() : reject()))

export const alert = (message: string): Promise<*> =>
  new Promise((resolve) => {
    global.alert(message)
    resolve()
  })
